<template>
    <div class="vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="backtofaktur">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Detail Kehadiran</div>
                <div class="header-top--right">
                    <div class="header-item">
                    </div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page">
            <div class="m-t-16 m-d-16 p-x-20 w-limit">
                <div class="f-18 f-bold">{{datafakturgaji.nama_karyawan_Faktur}}</div>
                <div class="m-t-4 f-14 m-d-16 f-c-midgrey">{{datafakturgaji.periode_format_Faktur}}</div>
            </div>

            <div class="separator-line w-limit"></div>

            <div class="m-t-16 m-d-16 p-x-20 w-limit">
                <div class="f-14 f-c-midgrey absensi-wrapper">
                    <div><b>Masuk kerja:</b> {{datadetailabsen.masuk_kerja_kehadiran}} Hari</div>
                    <div><b>Alpha:</b> {{datadetailabsen.alpha_Kehadiran}} Hari</div>
                    <div><b>Sakit:</b> {{datadetailabsen.Sakit_Kehadiran}} Hari</div>
                    <div><b>Cuti:</b> {{datadetailabsen.Cuti_Kehadiran}} Hari</div>
                    <div><b>Tanpa Status:</b> {{datadetailabsen.TanpaStatus_Kehadiran}} Hari</div>
                </div>
                <div class="m-t-16" >
                    <button class="btn btn-outline-small" @click="gotoUbahAbsensi"><span class="icon-edit"></span>Ubah Absensi</button>
                </div>
            </div>

            <div class="separator"></div>

            <div class="m-t-16 m-d-16 p-x-20 w-limit">
                <div class="f-16 f-bold">Keterlambatan</div>
                <div class="color-6f7 font-14 line-height-21 letter-space-002" v-if="datadetailabsen.durasi_keterlambatan.raw<=0">Belum ada</div>
                <div class="m-t-8 f-14 f-c-midgrey terlambat-wrapper" v-else>
                    <div><b>Durasi:</b> {{alltostring(datadetailabsen.durasi_keterlambatan.raw)}} Menit</div>
                    <div><b>Denda:</b>  {{datadetailabsen.nominal_keterlambatan.raw | currency}}</div>
                </div>
                <div class="m-t-16">
                    <div class="btn btn-outline-small" @click="addKeterlambatan"><span
                            class="icon-edit"></span>Atur data keterlambatan</div>
                </div>
            </div>
        </div>

        <!-- MODAL -->
        <div class="modal fade" id="modalketerlambatan" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-head w-limit">
                        <div class="modal-head--left"></div>
                        <h5 class="f-16 f-bold">Keterlambatan</h5>
                        <div class="modal-head--right" data-dismiss="modal">
                            <img src="../../../assets/img/x2.svg" alt="">
                        </div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="modal-bodyy w-limit w-100 p-x-20">

                        <div class="m-t-16">

                            <label for="form2" class="m-t-16 form-label">Durasi Terlambat</label>
                            <InputRupiah
                                    :outerDivClass="'input-group mod'"
                                    v-model="formTerlambat.durasi_keterlambatan"
                                    innerDivClass="input-group-prepend"
                                    :showRp="true"
                                    showRpPosition="right"
                                    showRpText="Menit"
                                    :id="'form2'"
                                    :defaultValue="formTerlambat.durasi_keterlambatan.formatted"
                                    :placeholder="15"/>


                            <label for="form2" class="m-t-16 form-label">Nominal Denda</label>
                            <InputRupiah
                                    :outerDivClass="'input-group mod'"
                                    v-model="formTerlambat.nominal_keterlambatan"
                                    innerDivClass="input-group-prepend"
                                    :showRp="true"
                                    :id="'form2'"
                                    :defaultValue="formTerlambat.nominal_keterlambatan.formatted"
                                    :placeholder="100000"/>


                            <div class="button-wrapper m-t-4 p-y-20 w-limit w-100">
                                <button class="btn smart-primary" id="BtnModalKeterlambatan"
                                        @click="simpanketerlambatan">Simpan</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import InputRupiah from "@/component-items/InputRupiah";
    export default {
        name:'DetailKehadiran',
        components: { InputRupiah },
        props:['databayargaji','datafakturgaji','datadetailabsen'],
        data(){
            return{
                formTerlambat:{
                    durasi_keterlambatan:{
                        formatted:"",
                        raw:0
                    },
                    nominal_keterlambatan:{
                        formatted:"",
                        raw:0
                    },
                }

            }
        },
        mounted() {
            this.inputCalc_keterlambatan();
            console.log(this.datadetailabsen.arraydatahadir.length)
        },
        methods:{
            backtofaktur(){
                this.$emit('backtofaktur');
            },

            gotoUbahAbsensi(){
                this.$emit('gotoUbah_Absensi')
            },

            alltostring(nominal){
                var afterall = nominal
                var afterallstring = this.newrupiahDenda(afterall.toString());
                return afterallstring
            },

            addKeterlambatan() {
                this.formTerlambat.nominal_keterlambatan=this.datadetailabsen.nominal_keterlambatan;
                this.formTerlambat.durasi_keterlambatan=this.datadetailabsen.durasi_keterlambatan;
                $('#modalketerlambatan').modal('show');
            },
            simpanketerlambatan(){

                this.datadetailabsen.nominal_keterlambatan.raw=this.formTerlambat.nominal_keterlambatan.raw;
                this.datadetailabsen.nominal_keterlambatan.formatted=this.formTerlambat.nominal_keterlambatan.formatted;
                this.datadetailabsen.durasi_keterlambatan.raw=this.formTerlambat.durasi_keterlambatan.raw;
                this.datadetailabsen.durasi_keterlambatan.formatted=this.formTerlambat.durasi_keterlambatan.formatted;
                // this.datadetailabsen.durasi_keterlambatan=this.formTerlambat.durasi_keterlambatan;
                //
                // var arraypotonganStaticLambat = [];
                // var nominalKeterlambatan = this.datadetailabsen.nominal_keterlambatan.raw;
                // var durasi = this.datadetailabsen.durasi_keterlambatan.raw;
                //
                // arraypotonganStaticLambat.push({
                //     nominaketerlambatan: nominalKeterlambatan,
                //     waktuketerlambatan:durasi
                //
                // });
                //
                // this.datadetailabsen.arraydatahadir = arraypotonganStaticLambat;
                // var total_tanggungan_Denda = this.datafakturgaji.nominal_tanggungan_fix;
                // total_tanggungan_Denda = total_tanggungan_Denda + nominalKeterlambatan;
                // this.datafakturgaji.nominal_tanggungan_fix = parseInt(total_tanggungan_Denda);
                $('#modalketerlambatan').modal('hide');
            },


            newrupiahDenda(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            inputCalc_keterlambatan() {
                var self = this;
                $('.number-counter').each(function(i, obj)  {

                    var inputx = $(this).children('input');
                    var increment = $(this).children('.inc');
                    var decrement = $(this).children('.dec');
                    var suffix = $(this).children('.input-suffix');
                    var suffixWidth = suffix.width();

                    // suffix positioning
                    suffix.css('left', "calc(50% - (" + suffixWidth + "px / 3) + 3px)");
                    suffix.prev().css('padding-right', 'calc(50% + (' + suffixWidth + 'px / 3))');

                    // select all if click
                    inputx.click(function () {
                        $(this).select()
                    });

                    // input limit
                    inputx.on('input', function () {
                        var value = $(this).val();
                        if ((value !== '') && (value.indexOf('.') === -1)) {
                            $(this).val(Math.max(Math.min(value, $(this).attr('max')), $(this).attr('min')));
                        }
                        if (value == '') {
                            $(this).val($(this).attr('min'));
                        }

                    });

                    // increment button
                    increment.click(function(){
                        var inputz = $(this).siblings('input');
                        if (inputz.val() < parseInt(inputz.attr('max'))){
                            inputz.val(parseInt(inputz.val())+1);
                        }
                    });

                    // decrement button
                    decrement.click(function() {
                        var inputz = $(this).siblings('input');
                        if (inputz.val() > parseInt(inputz.attr('min'))){
                            inputz.val(parseInt(inputz.val())-1)
                        }
                    });
                })


            },
        }
    }
</script>

<style>
    .absensi-wrapper div:not(:last-child),
    .terlambat-wrapper div:not(:last-child) {
        margin-bottom: 4px;
    }
</style>